module.exports = __webpack_public_path__ + "static/media/linear-clock.28e2d1b8.svg";